import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormSub from '@/components/Subscription/FormSub';
import { getDetail } from '@/services/packageService';
import { useBeforeRender } from '@/hooks/useBeforeRender';
import { Spin } from 'antd';

function Form({ id }) {
  const [loading, setLoading] = useState(true);
  const [pk, setPk] = useState();
  const fetchData = async () => {
    const { success, data } = await getDetail({ id });
    if (success) {
      setPk(data);
    }
    setLoading(false);
  };

  useBeforeRender(() => fetchData(), []);

  return <Spin spinning={loading}>{pk && <FormSub data={pk} />}</Spin>;
}

Form.propTypes = {
  id: PropTypes.string,
};

export default Form;
